import { useState } from "react";
import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "Home", href: "/explore", isRoute: true },
  { label: "Platform", href: "/explore#platform", isRoute: true },
  { label: "Consent", href: "/consent-management", isRoute: true, active: true },
  { label: "Variance", href: "#variance" },
  { label: "Templates", href: "#templates" },
  { label: "Cookies", href: "#cookies" },
  { label: "DSAR", href: "#dsar" },
];

export default function ConsentNavbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-[100] bg-ink/[.92] backdrop-blur-[14px] border-b border-white/[.06] py-[0.85rem]">
      <div className="container mx-auto max-w-[1140px] px-4 flex items-center justify-between flex-wrap">
        <Link
          to="/explore"
          className="font-figtree font-bold text-[1.35rem] text-white tracking-[-0.01em] inline-flex items-center gap-[0.6rem]"
        >
          <img
            src="/assets/onedpdp-logo.png"
            alt=""
            width="36"
            height="36"
            className="h-9 w-9 object-cover rounded block bg-white"
          />
          One<span className="text-gold font-bold">DPDP</span>
        </Link>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          className="lg:hidden border border-white/25 rounded p-2"
        >
          <span className="block w-6 h-0.5 bg-white mb-1" />
          <span className="block w-6 h-0.5 bg-white mb-1" />
          <span className="block w-6 h-0.5 bg-white" />
        </button>

        <div
          className={`${
            open ? "flex" : "hidden"
          } w-full lg:flex lg:w-auto flex-col lg:flex-row lg:items-center gap-1 mt-3 lg:mt-0`}
        >
          <ul className="flex flex-col lg:flex-row lg:items-center gap-1 list-none m-0 p-0">
            {NAV_LINKS.map((link) =>
              link.isRoute ? (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className={`block font-medium text-[0.92rem] px-[0.85rem] py-[0.4rem] transition-colors ${
                      link.active ? "text-white" : "text-white/[.72] hover:text-white"
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              ) : (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className={`block font-medium text-[0.92rem] px-[0.85rem] py-[0.4rem] transition-colors ${
                      link.active ? "text-white" : "text-white/[.72] hover:text-white"
                    }`}
                  >
                    {link.label}
                  </a>
                </li>
              )
            )}
            <li className="lg:ml-2 mt-2 lg:mt-0">
              <a
                href="#contact"
                className="inline-block bg-teal hover:bg-teal-bright text-white font-semibold rounded px-[1.35rem] py-[0.65rem] transition-all hover:-translate-y-px"
              >
                Request a demo
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
